import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ESYOHWidgets from './ESYOHWidgets';

const {
  FiArrowUpRight,
  FiBookOpen,
  FiHome,
  FiTrendingUp,
  FiDollarSign
}=FiIcons;

const benefits=[
  {
    icon: FiArrowUpRight,
    title: 'Low Barrier to Entry',
    text: 'No 4-year degree or prior experience required. Get job-ready with targeted certification prep in months, not years.'
  },
  {
    icon: FiHome,
    title: 'Remote Work & Flexibility',
    text: 'Thousands of billing and coding professionals work 100% remotely from home or enjoy hybrid, flexible schedules.'
  },
  {
    icon: FiTrendingUp,
    title: 'Exceptional Job Security',
    text: 'Healthcare demand is expanding rapidly, creating continuous long-term stability across hospitals, clinics, and billing agencies.'
  },
  {
    icon: FiDollarSign,
    title: 'Strong Earning Potential',
    text: 'Earn competitive hourly wages and full benefits without accumulating massive student loan debt.'
  }
];

const statistics=[
  ['2025 Median Pay','$51,140 / year','$24.59 per hour'],
  ['Typical Entry-Level Education','Postsecondary nondegree award',''],
  ['Work Experience Required','None',''],
  ['Total Jobs (2025)','200,700',''],
  ['Job Outlook (2025–2035)','8% Growth','Much faster than national average'],
  ['Projected Employment Change','+15,600','new jobs']
];

function CareerOutlook() {
  const navigate=useNavigate();

  return (
    <section style={{
      padding: '88px 0',
      color: '#082f49',
      background: '#f8fafc'
    }}>
      <div className="container">
        <div style={{
          maxWidth: '760px',
          margin: '0 auto 40px',
          textAlign: 'center'
        }}>
          <span style={{
            display: 'inline-block',
            marginBottom: '12px',
            color: '#0f766e',
            fontSize: '0.75rem',
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.17em'
          }}>
            Career Opportunities &amp; Industry Outlook
          </span>
          <h2 style={{
            marginBottom: '18px',
            color: '#082f49',
            fontFamily: 'Manrope, sans-serif',
            fontSize: 'clamp(2rem,4vw,3rem)',
            lineHeight: 1.12,
            letterSpacing: '-0.045em'
          }}>
            A High-Growth Healthcare Career Without the 4-Year Degree
          </h2>
          <p style={{
            color: '#64748b',
            fontSize: '1rem',
            lineHeight: 1.75
          }}>
            Medical billing and coding offers one of the fastest, most affordable pathways into the healthcare industry with remote flexibility and reliable earning potential.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
          gap: '16px',
          marginBottom: '28px'
        }}>
          {benefits.map((benefit)=> (
            <article key={benefit.title} style={{
              minHeight: '225px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              background: '#ffffff',
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(15,42,66,0.04)'
            }}>
              <span style={{
                width: '44px',
                height: '44px',
                marginBottom: '20px',
                display: 'grid',
                placeItems: 'center',
                color: '#0369a1',
                background: '#e0f2fe',
                borderRadius: '11px'
              }}>
                <SafeIcon icon={benefit.icon} />
              </span>
              <h3 style={{
                marginBottom: '10px',
                color: '#0f2940',
                fontFamily: 'Manrope, sans-serif',
                fontSize: '1.05rem'
              }}>
                {benefit.title}
              </h3>
              <p style={{
                marginTop: 'auto',
                color: '#64748b',
                fontSize: '0.85rem',
                lineHeight: 1.65
              }}>
                {benefit.text}
              </p>
            </article>
          ))}
        </div>

        <div style={{
          padding: '24px',
          background: '#f0f9ff',
          border: '1px solid #bae6fd',
          borderRadius: '12px'
        }}>
          <div style={{marginBottom: '20px'}}>
            <h3 style={{
              marginBottom: '7px',
              color: '#0c4a6e',
              fontFamily: 'Manrope, sans-serif',
              fontSize: '1.35rem'
            }}>
              Quick Facts: Medical Records Specialists
            </h3>
            <p style={{
              color: '#0369a1',
              fontSize: '0.78rem',
              lineHeight: 1.5
            }}>
              Source: U.S. Bureau of Labor Statistics (BLS) Occupational Outlook Handbook
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))',
            gap: '12px'
          }}>
            {statistics.map(([label,value,detail])=> (
              <div key={label} style={{
                minHeight: '104px',
                padding: '15px',
                background: '#ffffff',
                border: '1px solid #dbeafe',
                borderRadius: '9px'
              }}>
                <span style={{
                  display: 'block',
                  marginBottom: '8px',
                  color: '#64748b',
                  fontSize: '0.72rem',
                  fontWeight: 700,
                  lineHeight: 1.35
                }}>
                  {label}
                </span>
                <strong style={{
                  display: 'block',
                  color: '#0c4a6e',
                  fontFamily: 'Manrope, sans-serif',
                  fontSize: '1.05rem',
                  lineHeight: 1.3
                }}>
                  {value}
                </strong>
                {detail && (
                  <small style={{
                    display: 'block',
                    marginTop: '5px',
                    color: '#0369a1',
                    fontSize: '0.72rem',
                    lineHeight: 1.4
                  }}>
                    {detail}
                  </small>
                )}
              </div>
            ))}
          </div>

          <div style={{
            marginTop: '20px',
            padding: '18px',
            background: '#ffffff',
            border: '1px solid #dbeafe',
            borderLeft: '4px solid #0284c7',
            borderRadius: '9px'
          }}>
            <h4 style={{
              marginBottom: '7px',
              color: '#0c4a6e',
              fontSize: '0.95rem'
            }}>
              Compare the Investment
            </h4>
            <p style={{
              color: '#526a7d',
              fontSize: '0.84rem',
              lineHeight: 1.65
            }}>
              Traditional 4-year healthcare degrees can cost $40,000–$100,000+ in tuition. Medical coding certification prep costs a tiny fraction of that, allowing students to start earning $50,000+ per year much faster with zero debt burden.
            </p>
          </div>
        </div>

        <div style={{
          marginTop: '38px',
          padding: '28px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
          flexWrap: 'wrap',
          textAlign: 'left',
          background: '#082f49',
          borderRadius: '12px'
        }}>
          <div>
            <span style={{
              display: 'block',
              marginBottom: '6px',
              color: '#99f6e4',
              fontSize: '0.72rem',
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.1em'
            }}>
              Begin your learning path
            </span>
            <strong style={{
      color: 'rgb(255, 255, 255)',
      fontFamily: 'Manrope, sans-serif',
      fontSize: '1.2rem'
    }}>Ready to start your first medical coding class?</strong>
          </div>
          <button
            type="button"
            onClick={()=> navigate('/module/foundations-medical-terminology')}
            style={{
              padding: '12px 24px',
              color: '#ffffff',
              fontWeight: 800,
              background: '#0284c7',
              border: 0,
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            <SafeIcon icon={FiBookOpen} style={{display: 'inline-block',marginRight: '8px',verticalAlign: 'middle'}} />
            Start Module 1: Revenue Cycle Basics
          </button>
        </div>
      </div>
      <div className="container" style={{ margin: '2rem auto' }}>
          <ESYOHWidgets widgetId="940985" />
        </div>
    </section>
  );
}

export default CareerOutlook;